"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "tabs", {
  enumerable: true,
  get: function get() {
    return _tabs["default"];
  }
});
var _tabs = _interopRequireDefault(require("./tabs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }